// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
     suggestionMobileStyle: 'style2', // style1, style2
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
  	
  SearchInput.prototype.render = function() {
    if(Utils.isMobile()) {
      this.$element.val('')
      .addClass(Class.searchBox)
      .attr('autocomplete', 'off')
      .attr('id', this.id)
      .attr('data-search-box', this.id)
      .attr('role', 'combobox')
      .attr('placeholder', Labels.suggestion.searchBoxPlaceholder)
      .attr('aria-expanded', false)
      .attr('aria-autocomplete', 'list')
      .attr('aria-label', Labels.ada.searchAutoComplete)
      .attr('aria-owns', this.id.replace(Class.searchBox, Class.searchSuggestion))
      .attr('data-already-init', true);
      this.isRendered = true;
    } else {
    	var queryValue = Utils.getParam(Globals.searchTermKey);
		this.$element.val(queryValue)
			.addClass(Class.searchBox)
			.attr('autocomplete', 'off')
			.attr('id', this.id)
			.attr('data-search-box', this.id)
			.attr('role', 'combobox')
			.attr('placeholder', Labels.suggestion.searchBoxPlaceholder)
			.attr('aria-expanded', false)
			.attr('aria-autocomplete', 'list')
			.attr('aria-label', Labels.ada.searchAutoComplete)
			.attr('aria-owns', this.id.replace(Class.searchBox, Class.searchSuggestion))
			.attr('data-already-init', true);
		this.isRendered = true;
    }
  }
  
   InstantSearchMobile.prototype.closeInstantSearchMobile = function(isClose) {
		// Close Suggestion box
		this.searchBox.instantSearchResult.$wrapper.hide();
		// Remove search box
		var isClose = typeof isClose !== 'undefined' ? isClose : false;
		if (isClose) {
			this.$topPanelElement.hide();
			this.$overlayElement.hide();
		}
     	
     	// Update current term for all search boxes
		this._setValueAllSearchBoxes('');
		// Add back tabindex=-1
		jQ('.' + Class.searchSuggestionNoTabIndex).attr('tabindex', -1);
		// Return scrolling of body
		if (jQ('body').hasClass(Class.searchSuggestionMobileOpen)) {
			jQ('body').removeClass(Class.searchSuggestionMobileOpen);
		}
		
     	jQ('.boost-pfs-search-suggestion-wrapper').removeClass('boost-pfs-search-suggestion-open')
     
		this.afterCloseInstantSearchMobile(isClose);
	}

    clearSuggestionMobile = function(id) {
      $(id).val("");
    } 
  
})();

